<template>
  <div class="scroll picker-container">
    <div class="month-title" v-if="disableDates && disableDates.ranges">
      <span>{{ selectedDates[0].display }}</span>
      <span>{{ selectedDates[1].display }}</span>
    </div>
    <div class="space-element">
      <vue-slider class="mr-20 ml-20" v-if="sliderValues && sliderValues.length > 0" v-model="monthRange" :max-range="sliderValues[sliderValues.length]" :tooltip="'always'" :data="sliderValues" height="17" :dotSize="40" :dotWidth="20" @drag-end="dragEnd" ref="slider" :marks="true" :formatter="val => (val ? val.toUpperCase() : val)" />
    </div>
    <div class="display-flex" v-if="disableDatesStart && disableDatesEnd">
      <div class="date-input">
        <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Date" v-model="dataPickerFromValue" :format="datePickerFormat" :disabled-dates="disableDatesStart" name="datepicker" @input="changeFromPicker" ref="startDatePicker"> </datepicker>
        <img src="/static/img/calendar.svg" @click="openStartDatePicker" class="date-cal-icon" />
      </div>
      <div class="date-to">to</div>
      <div class="date-input">
        <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Date" v-model="dataPickerToValue" :format="datePickerFormat" :disabled-dates="disableDatesEnd" @input="changeFromPicker" name="datepickerTo" ref="endDatePicker"> </datepicker>
        <img src="/static/img/calendar.svg" @click="openEndDatePicker" class="date-cal-icon" />
      </div>
    </div>
  </div>
</template>
<script>
import VueSlider from "vue-slider-component";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import _ from "lodash";

export default {
  components: {
    VueSlider,
    datepicker: Datepicker
  },

  props: {
    title: { type: String, default: "Month Slider" },
    dataPicker: { type: Array, default: () => [] },
    calendarShow: {},
    studyStartDate: {}
  },

  data() {
    return {
      monthRange: [],
      sliderValues: [],
      selectedDates: {},
      datePickerFormat: "dd MMM yyyy",
      dataPickerFromValue: new Date(),
      dataPickerToValue: new Date(),
      disableDates: null,
      disableDatesStart: null,
      disableDatesEnd: null
    };
  },

  watch: {
    dataPicker: function(value) {
      this.sliderValues = this.lastMonthCheck(value);
      this.renderPicker(this.sliderValues);
    },
    calendarShow: () => {
      this.refreshSlide();
    }
  },

  methods: {
    dragEnd() {
      let monthSelection = this.monthRange;
      let lastDate = new Date(new Date(monthSelection[1]).setMonth(new Date(monthSelection[1]).getMonth() + 1));
      if (new Date(monthSelection[1]).getMonth() === new Date().getMonth() && new Date(monthSelection[1]).getFullYear() === new Date().getFullYear()) {
        lastDate = new Date();
      } else {
        lastDate = new Date(lastDate.setDate(lastDate.getDate() - 1));
      }
      const firstDate = new Date(monthSelection[0]);
      monthSelection = [
        {
          display: moment(monthSelection[0])
            .format("DD MMM YYYY")
            .toUpperCase(),
          value: moment(monthSelection[0]).format("YYYY-MM-DD")
        },
        {
          display: moment(lastDate)
            .format("DD MMM YYYY")
            .toUpperCase(),
          value: moment(lastDate).format("YYYY-MM-DD")
        }
      ];
      this.selectedDates = monthSelection;
      this.dataPickerFromValue = firstDate;
      this.dataPickerToValue = lastDate;
      this.disableDatesStart = {
        ranges: [{ from: lastDate, to: new Date(2050, 12, 31) }]
      };
      this.disableDatesEnd = {
        ranges: [
          { from: new Date(1970, 0, 1), to: firstDate },
          { from: new Date(), to: new Date(2050, 12, 31) }
        ]
      };
      this.emitPicker(monthSelection);
    },
    changeFromPicker() {
      this.emitPicker(this.dateChanged());
      const startDate = this.dataPickerFromValue;
      const endDate = this.dataPickerToValue;

      this.disableDatesStart = {
        ranges: [{ from: endDate, to: new Date(2050, 12, 31) }]
      };
      this.disableDatesEnd = {
        ranges: [
          { from: new Date(1970, 1, 1), to: startDate },
          { from: new Date(), to: new Date(2050, 12, 31) }
        ]
      };
    },
    emitPicker(monthSelection) {
      this.$emit("onDragEnd", monthSelection);
    },
    dateChanged() {
      const monthSelection = [this.dataPickerFromValue, this.dataPickerToValue];
      const monthRange = [moment(monthSelection[0]).format("MMM YYYY"), moment(monthSelection[1]).format("MMM YYYY")];
      const datePicker = [];
      const lesserValue = this.dataPickerFromValue.getTime() < this.studyStartDate ? this.dataPickerFromValue : this.studyStartDate;
      for (let m = moment(lesserValue); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
        if (m.format("MMM YYYY") === moment().format("MMM YYYY")) {
          break;
        }
      }
      this.sliderValues = datePicker;
      this.monthRange = monthRange;
      this.selectedDates = [
        {
          display: moment(monthSelection[0])
            .format("DD MMM YYYY")
            .toUpperCase(),
          value: moment(monthSelection[0]).format("YYYY-MM-DD")
        },
        {
          display: moment(monthSelection[1])
            .format("DD MMM YYYY")
            .toUpperCase(),
          value: moment(monthSelection[1]).format("YYYY-MM-DD")
        }
      ];
      return this.selectedDates;
    },
    renderPicker(dataPicker) {
      const minPicker = dataPicker.length > 0 ? 0 : 0;
      const maxPicker = dataPicker.length > 1 ? dataPicker.length - 1 : 0;

      const firstMonth = dataPicker[minPicker] ? dataPicker[minPicker] : new Date();
      const lastMonth = dataPicker[maxPicker] ? dataPicker[maxPicker] : new Date();

      this.monthRange = [firstMonth, lastMonth];
      const ranges = {
        ranges: [{ from: new Date(), to: new Date(2050, 12, 31) }]
      };
      this.dataPickerFromValue = new Date(this.studyStartDate);
      this.dataPickerToValue = new Date();
      this.disableDates = ranges;
      this.disableDatesStart = ranges;
      this.disableDatesEnd = {
        ranges: [
          { from: new Date(1970, 0, 1), to: this.dataPickerFromValue },
          { from: new Date(), to: new Date(2050, 12, 31) }
        ]
      };
    },
    refreshSlide() {
      if (this.$refs.slider) {
        this.$refs.slider.refresh();
      }
    },
    lastMonthCheck(months) {
      return _.filter(months, month => {
        return new Date().getTime() > new Date(month).getTime();
      });
    },
    openStartDatePicker() {
      this.$refs.endDatePicker.close();
      this.$refs.startDatePicker.showCalendar();
    },
    openEndDatePicker() {
      this.$refs.startDatePicker.close();
      this.$refs.endDatePicker.showCalendar();
    }
  },

  mounted() {
    this.sliderValues = this.lastMonthCheck(this.dataPicker);
    this.renderPicker(this.sliderValues);
    this.$emit("init", this.dateChanged());
    this.refreshSlide();
  }
};
</script>
<style lang="scss" scoped>
.space-element {
  margin-top: 40px;
}

.date-cal-icon {
  cursor: pointer;
}
</style>
